import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const token = localStorage.getItem("esg_token");
      if (token) {
        const { data } = await axios.get(`${API}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
          timeout: 5000
        });
        setUser(data);
      } else {
        const { data } = await axios.get(`${API}/auth/me`, { withCredentials: true, timeout: 5000 });
        setUser(data);
      }
    } catch {
      localStorage.removeItem("esg_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
    if (data.token) localStorage.setItem("esg_token", data.token);
    setUser(data);
    return data;
  };

  const register = async (email, password, name, extra = {}) => {
    const { data } = await axios.post(`${API}/auth/register`, { email, password, name, ...extra }, { withCredentials: true });
    if (data.token) localStorage.setItem("esg_token", data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch { /* ignore */ }
    localStorage.removeItem("esg_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
